export default function ({ $auth, redirect, route }) {
    let user = $auth.user
    if (!user || !user.region) {
        if (!(route.name === "region-slug" && user?.region)) {
            redirect("/")
        }
    }
}
